import { render, staticRenderFns } from "./input.message.vue?vue&type=template&id=85875068&scoped=true"
import script from "./input.message.vue?vue&type=script&lang=js"
export * from "./input.message.vue?vue&type=script&lang=js"
import style0 from "./input.message.vue?vue&type=style&index=0&id=85875068&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85875068",
  null
  
)

export default component.exports